import { render, staticRenderFns } from "./PageBIKEHALL.vue?vue&type=template&id=220a2f83"
import script from "./PageBIKEHALL.vue?vue&type=script&lang=js"
export * from "./PageBIKEHALL.vue?vue&type=script&lang=js"
import style0 from "./PageBIKEHALL.vue?vue&type=style&index=0&id=220a2f83&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports